// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 362 ? "b6715477" : chunkId) + "." + {"362":"ddd413a80ecde33b","684":"a542a9c01315cad9","910":"d6096feac894af5e"}[chunkId] + ".js";
};